import {LoaderOvalIcon} from "../icons/loaders";

export const LoaderButton = () => (
    <div className="flex items-center justify-center">
        {/*className="inline text-primary h-4 w-4 mr-1"*/}
        <LoaderOvalIcon className="h-3.5 w-3.5 mr-2"/>
    </div>
);
